<template>
  <div class="admin-settings">
    <header-title :title="title"></header-title>

    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
    <br />
    <v-container fluid>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Nombre :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              name="name"
              type="text"
              v-model="input.company.name"
              label="Nombre"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Nombre corto :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              name="name"
              type="text"
              v-model="input.company.shortName"
              label="Nombre corto"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Dirección :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-textarea
              name="input-7-1"
              v-model="input.company.address"
              label="Dirección"
              rows="2"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Empresa :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.company.company"
              label="Empresa"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Datos registrales :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.company.registerData"
              label="Datos registrales"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Nif :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.company.nif"
              label="Nif"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              IVA :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              type="number"
              v-model="input.company.iva"
              label="IVA"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Web :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.company.web"
              label="Web"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Email de contacto :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.company.email"
              label="Email de contacto"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Email de facturación :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field
              v-model="input.company.invoice_email"
              label="Email de facturación"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Numeración de Factura :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-text-field v-model="input.company.inv_number"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col align="center">
            <div class="my-2 mr-5">
              <v-btn
                dense
                outlined
                @click="onSaveSetting"
                type="button"
                :style="adminNavigationBackTheme"
              >
                Guardar
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import Loader from "@/components/common/Loader";
import firebaseMixin from "../../../mixins/firebase/firebaseMixin";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { getSettingById, saveSetting } from "@/collections/settings";

const EMPTY_COMPANY = {
  name: "",
  shortName: "",
  address: "",
  company: "",
  nif: "",
  iva: 10,
  web: "",
  email: "",
  invoice_email: "",
  registerData: "",
  inv_number: null
};

export default {
  name: "Settings-Info",
  components: { Loader, HeaderTitle },
  mixins: [firebaseMixin],
  data() {
    return {
      dialogLoader: false,
      title: "Información de la Empresa",
      input: {
        company: EMPTY_COMPANY
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      let self = this;
      this.dialogLoader = true;

      let setting;
      try {
        setting = await getSettingById("settings");

        self.dialogLoader = false;
        self.input = setting;

        if (self.input.company === undefined) {
          self.input = {
            ...self.input,
            company: EMPTY_COMPANY
          };
        }
      } catch (error) {
        this.setlogError(
          "get_setting",
          "Error obteniendo settings",
          error.stack,
          this.$options.name
        );
        self.dialogLoader = false;
      }
    },
    async onSaveSetting() {
      await saveSetting("settings", {
        ...this.input
      });

      this.showSuccessMessage("Información de la empresa guardada");
    }
  }
};
</script>

<style scoped lang="scss">
.icons-img {
  width: 100px;
  height: 100px;
  align-items: center;
  display: flex;
  padding: 10px;
  border: 2px solid darkgray;
  justify-content: center;
  min-width: 100px;
}
.icons-img img {
  max-width: 100%;
  max-height: 80px;
}
</style>
